interface IRichTextSummary {
  content: any;
  char?: number;
  url?: string;
  buttonEnabled?: boolean;
}

interface IItem {
  type: string;
  children: any;
  text: string;
}

export const richTextSummaryHandler = ({ content }: IRichTextSummary) => {
  return content
    ?.map((item: IItem) => {
      switch (item.type) {
        case "heading":
          return richTextSummaryHandler({ content: item.children });
        case "paragraph":
          return richTextSummaryHandler({ content: item.children });
        case "text":
          return item.text;
        default:
          return "";
      }
    })
    .join("");
};

const RichTextSummary = ({
  content,
  char,
  url,
  buttonEnabled,
}: IRichTextSummary) => {
  const contentHTML = richTextSummaryHandler({ content });
  return (
    <div className="RichTextSummary bg-gray-50 text-[#232323] text-base leading-relaxed font-body">
      {contentHTML?.substring(0, char)}...{' '}
      {!buttonEnabled && url && (
        <a href={url} className="text-gray-900 underline hover:text-[#232323] transition-colors font-heading font-bold uppercase text-sm">Read More</a>
      )}
      {buttonEnabled && url && (
        <>
          <br />
          <br />
          <a href={url} aria-label="Read More" className="block">
            <button
              className="w-full bg-gray-900 hover:bg-[#232323] text-gray-50 font-heading font-bold py-3 px-4 transition-all duration-200 border-2 border-gray-200 uppercase tracking-wider text-sm"
            >
              Read More
            </button>
          </a>
        </>
      )}
    </div>
  );
};

export default RichTextSummary;
